// components
import OpportunityCard from "../Cards/OpportunityCard";
import CommonActionModal from "../Common/CommonActionModal";

// icons
import WebAssetIcon from "@mui/icons-material/WebAsset";


class FinancialModelOpportunityCardWrapper extends CommonActionModal {
    async componentDidMount() {
        this.setState({
            buttonIcon: WebAssetIcon,
            buttonLabel: '',
            buttonColor: 'neutral',
            ready: true,
        })
    }

    async beforeModalOpen(){
        return {
            modalLabel: '',
            modalIcon: null,
            mainComponent: OpportunityCard,
            mainComponentProps: {
                showStatus: true,
                opportunity: this.props.componentObj.opportunity,
                comments: this.props.componentObj.comments,
                delivery_states: this.props.componentObj.delivery_states,
                my_roles: this.props.componentObj.my_roles,
            },
        }
    }
}

export default FinancialModelOpportunityCardWrapper